const HOLD_MIC_KEY = "orbiee_vto_hold_avatar_mic";

export function setVirtualTryOnHoldAvatarMic(hold = true) {
  try {
    if (hold) {
      sessionStorage.setItem(HOLD_MIC_KEY, "true");
      console.debug("[VTO] avatar mic hold enabled");
    } else {
      sessionStorage.removeItem(HOLD_MIC_KEY);
    }
  } catch (e) {
    console.warn("[VTO] setVirtualTryOnHoldAvatarMic:", e);
  }
}

export function isVirtualTryOnHoldingAvatarMic() {
  try {
    return sessionStorage.getItem(HOLD_MIC_KEY) === "true";
  } catch {
    return false;
  }
}

/**
 * Clear hold and notify the avatar widget it may re-enable the ambient mic.
 * @param {string} reason
 * @returns {boolean} whether a hold was active and released
 */
export function releaseVirtualTryOnAvatarMicHold(reason = "unknown") {
  if (!isVirtualTryOnHoldingAvatarMic()) return false;
  try {
    sessionStorage.removeItem(HOLD_MIC_KEY);
  } catch (_) {}
  console.debug("[VTO] avatar mic hold released", { reason });
  window.dispatchEvent(
    new CustomEvent("orbieeVirtualTryOnAvatarMicReleased", {
      detail: { reason, timestamp: Date.now() },
    })
  );
  return true;
}

export function notifyVirtualTryOnImageLoaded() {
  releaseVirtualTryOnAvatarMicHold("image_loaded");
}

export function notifyVirtualTryOnFailed() {
  releaseVirtualTryOnAvatarMicHold("failed");
}

export function notifyVirtualTryOnClosed() {
  releaseVirtualTryOnAvatarMicHold("closed");
}
